<div class="relative px-4 mb-4">
  <proffeo-ui-input
    [(value)]="search"
    variant="search"
    placeholder="placeholders.search-input"
  />
</div>

<div class="w-full flex flex-col h-full">
  @for (user of filteredUsers(); track user?.id; let isLast = $last) {
    <div class="flex items-center">
      <div
        [ngClass]="isLast ? '' : 'border-b border-proffeo-surface-off'"
        class="flex items-center w-full border-b border-proffeo-overlay-subtle py-1.5"
      >
        <mat-radio-button
          (click)="selectUser(user)"
          [value]="$safeNavigationMigration(user?.id)"
          [checked]="selectedUser() === user?.id"
          class="mr-2 shrink-0"
        />
        <proffeo-avatar
          [user]="user"
          [size]="AvatarSize.SM"
          [borderType]="AvatarBorderType.IndustryAdmin"
        />
        <div class="flex flex-col ml-2 py-2 w-full truncate">
          <p>{{ user?.firstName }} {{ user?.lastName }}</p>
        </div>
      </div>
    </div>
  }
</div>
